import { render, staticRenderFns } from "./AttributeValues.vue?vue&type=template&id=2e27e3dc"
import script from "./AttributeValues.vue?vue&type=script&lang=js"
export * from "./AttributeValues.vue?vue&type=script&lang=js"
import style0 from "./AttributeValues.vue?vue&type=style&index=0&id=2e27e3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports